import React, { useRef, useState } from 'react';
import Typography from '../../../../shared/components/Typography/Typography';
import Menu, { MenuItem } from '../../../../shared/components/Menu/Menu';
import { getPartnerRoleLabel, getPartnerDisplayName, getPartnerLifecycle } from '../partnerModel';

function PartnerHeader({ partner, verifying, onAddAction, onCreateAffair, onEditPartner, onEditContacts, onEditAgencies, onVerify }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuAnchor = useRef(null);
  const lifecycle = getPartnerLifecycle(partner.lifecycleStatus);
  const relationshipLabels = { prospect: 'Prospect', client: 'Client', client_inactif: 'Client inactif' };

  return (
    <div className="partner-page__header">
      <div className="partner-page__identity">
        <Typography variant="h4">{getPartnerDisplayName(partner)}</Typography>
        <div className="partner-page__meta">
          {(partner.roles || []).map((role) => <span key={role.code || role}>{getPartnerRoleLabel(role)}</span>)}
          <span>{lifecycle.label}</span>
          <span className={`partner-relationship partner-relationship--${partner.relationshipStatus}`}>{relationshipLabels[partner.relationshipStatus] || 'Prospect'}</span>
          {partner.city && <span>{partner.city}</span>}
          <span>Dernière interaction : {partner.lastCommercialActivityAt ? new Date(partner.lastCommercialActivityAt).toLocaleDateString('fr-FR') : 'aucune'}</span>
          <span>Prochaine relance : {partner.nextFollowUpAt ? new Date(partner.nextFollowUpAt).toLocaleDateString('fr-FR') : 'aucune'}</span>
        </div>
      </div>
      <div className="partner-page__actions">
        <button className="basic-button active" type="button" onClick={onAddAction}>Ajouter une action</button>
        <button className="basic-button" type="button" onClick={onCreateAffair}>Nouvelle affaire</button>
        <button className="basic-button" type="button" onClick={onEditPartner}>Modifier</button>
        <button ref={menuAnchor} className="basic-button partner-page__more" type="button" aria-label="Actions secondaires" aria-haspopup="menu" aria-expanded={menuOpen} onClick={() => setMenuOpen((open) => !open)}>⋯</button>
        <Menu open={menuOpen} anchorRef={menuAnchor} anchorOrigin={{ horizontal: 'right' }} transformOrigin={{ horizontal: 'right' }} onClose={() => setMenuOpen(false)}>
          <MenuItem onClick={() => { setMenuOpen(false); onEditContacts(); }}>Modifier les contacts</MenuItem>
          <MenuItem onClick={() => { setMenuOpen(false); onEditAgencies(); }}>Modifier les agences</MenuItem>
          <MenuItem disabled={verifying} onClick={() => { setMenuOpen(false); onVerify(); }}>{verifying ? 'Vérification…' : 'Marquer les données légales comme vérifiées'}</MenuItem>
        </Menu>
      </div>
    </div>
  );
}

export default PartnerHeader;
